class PieceworkAnnouncementBar extends window.HTMLElement {
  constructor() {
    super();

    this.annoucements = this.querySelectorAll('[data-announcement]');
    this.featureToggle = this.querySelectorAll('[data-feature-dialog]');
    this.backdrop = this.querySelector('[data-backdrop]');
    this.featureClose = this.querySelector('[data-feature-close]');
    this.swiper = this.querySelector('[data-swiper]');
    this.open = false;
  }

  toggleFeatures() {
    if (this.open) {
      this.classList.remove('open');
      this.open = false;
    } else {
      this.classList.add('open');
      this.open = true;
    }
  }

  connectedCallback() {
    this.featureToggle.forEach((feature, i) => {
      feature.addEventListener('click', () => {
        this.toggleFeatures();
      });
    });

    this.featureClose.addEventListener('click', () => {
      this.toggleFeatures();
    });

    this.backdrop.addEventListener('click', () => {
      this.toggleFeatures();
    });

    this.annoucements.forEach((announcement, i) => {
      const dialogOpen = announcement.querySelector('[dialog-open]');
      const dialogClose = announcement.querySelector('[dialog-close]');
      const dialog = announcement.querySelector('dialog');

      dialogOpen.addEventListener('click', () => {
        dialog.showModal();
      });

      dialogClose.addEventListener('click', () => {
        dialog.close();
      });

      dialog.addEventListener('click', (event) => {
        const rect = dialog.getBoundingClientRect();
        if (
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom
        ) {
          dialog.close();
        }
      });
    });

    if (this.swiper) {
      let width = 0;
      const swiper = this.swiper.querySelector('swiper-container');
      const slides = swiper.querySelectorAll('swiper-slide > div');
      const swiperContainer = this.swiper;

      Object.assign(swiper, {
        autoplay: {
          delay: 5000,
        },
        loop: true,
        on: {
          init() {
            slides.forEach((slide, i) => {
              console.log(slide);
              if (slide.offsetWidth > width) {
                width = slide.offsetWidth;
              }
            });
            swiperContainer.style.setProperty('--swiper-width', `${width + 5}px`);
            swiperContainer.classList.remove('tw-opacity-0');
          },
        },
      });
      swiper.initialize();
    }
  }
}

window.customElements.define('piecework-announcement-bar', PieceworkAnnouncementBar);
